import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button.jsx';
import { Input } from '../components/ui/input.jsx';
import { Label } from '../components/ui/label.jsx';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select.jsx';
import Logo from '../components/Logo.js';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CompanyRegister = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    razao_social: '',
    cnpj: '',
    porte: '',
    regiao: '',
    segmento: '',
    total_funcionarios: '',
    email: '',
    telefone: ''
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/companies/register`, formData);
      toast.success('Empresa cadastrada com sucesso! Um email com token de acesso foi enviado.');
      navigate('/login');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao cadastrar empresa');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4" data-testid="register-page">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-8">
          <div className="text-center mb-8">
            <Logo size="large" className="justify-center mb-4" />
            <h2 className="text-2xl font-bold text-slate-900">Cadastro de Empresa</h2>
            <p className="text-slate-600 mt-2">Preencha os dados da sua organização</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-testid="company-register-form">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-2">
                <Label htmlFor="razao_social">Razão Social *</Label>
                <Input
                  id="razao_social"
                  value={formData.razao_social}
                  onChange={(e) => handleChange('razao_social', e.target.value)}
                  required
                  data-testid="input-razao-social"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="cnpj">CNPJ *</Label>
                <Input
                  id="cnpj"
                  value={formData.cnpj}
                  onChange={(e) => handleChange('cnpj', e.target.value)}
                  placeholder="00.000.000/0000-00"
                  required
                  data-testid="input-cnpj"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="porte">Porte *</Label>
                <Select onValueChange={(value) => handleChange('porte', value)} required>
                  <SelectTrigger data-testid="select-porte">
                    <SelectValue placeholder="Selecione" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="micro">Micro</SelectItem>
                    <SelectItem value="pequeno">Pequeno</SelectItem>
                    <SelectItem value="medio">Médio</SelectItem>
                    <SelectItem value="grande">Grande</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-2">
                <Label htmlFor="regiao">Região *</Label>
                <Select onValueChange={(value) => handleChange('regiao', value)} required>
                  <SelectTrigger data-testid="select-regiao">
                    <SelectValue placeholder="Selecione" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="norte">Norte</SelectItem>
                    <SelectItem value="nordeste">Nordeste</SelectItem>
                    <SelectItem value="centro-oeste">Centro-Oeste</SelectItem>
                    <SelectItem value="sudeste">Sudeste</SelectItem>
                    <SelectItem value="sul">Sul</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-2">
                <Label htmlFor="segmento">Segmento *</Label>
                <Input
                  id="segmento"
                  value={formData.segmento}
                  onChange={(e) => handleChange('segmento', e.target.value)}
                  placeholder="Ex: Tecnologia, Varejo, Indústria"
                  required
                  data-testid="input-segmento"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="total_funcionarios">Total de Funcionários *</Label>
                <Input
                  id="total_funcionarios"
                  type="number"
                  value={formData.total_funcionarios}
                  onChange={(e) => handleChange('total_funcionarios', e.target.value)}
                  required
                  data-testid="input-total-funcionarios"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="email">Email Corporativo *</Label>
                <Input
                  id="email"
                  type="email"
                  value={formData.email}
                  onChange={(e) => handleChange('email', e.target.value)}
                  required
                  data-testid="input-email"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="telefone">Telefone</Label>
                <Input
                  id="telefone"
                  value={formData.telefone}
                  onChange={(e) => handleChange('telefone', e.target.value)}
                  placeholder="(00) 00000-0000"
                  data-testid="input-telefone"
                />
              </div>
            </div>

            <div className="pt-6 border-t border-slate-200">
              <Button 
                type="submit" 
                className="w-full h-12" 
                disabled={loading}
                data-testid="submit-register-button"
              >
                {loading ? 'Cadastrando...' : 'Cadastrar Empresa'}
              </Button>

              <p className="text-center text-sm text-slate-500 mt-4">
                Já possui cadastro? <a href="/login" className="text-accent hover:underline" data-testid="login-link">Fazer login</a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CompanyRegister;